module.exports = __webpack_public_path__ + "img/markets-callaway.51151352.jpg";